// Updated import paths for React app structure - EnrollmentProcessor.js adapted from FaceTec sample
import { Config } from "../../Config.js";

// Simple mock for DeveloperStatusMessages for React
const DeveloperStatusMessages = {
  logMessage: (message) => {
    console.log(`FaceTec SampleApp: ${message}`);
  }
};

//
// Welcome to the annotated FaceTec Device SDK core code for performing secure Enrollment!
//
export var EnrollmentProcessor = /** @class */ (function () {
    function EnrollmentProcessor(sessionToken, userId, callback) {
        var _this = this;
        this.latestNetworkRequest = new XMLHttpRequest();
        //
        // Part 2:  Handling the Result of a FaceScan
        //
        this.processSessionResultWhileFaceTecSDKWaits = function (sessionResult, faceScanResultCallback) {
            _this.latestSessionResult = sessionResult;
            //
            // Part 3:  Handles early exit scenarios where there is no FaceScan to handle -- i.e. User Cancellation, Timeouts, etc.
            //
            if (sessionResult.status !== window.FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
                _this.latestNetworkRequest.abort();
                faceScanResultCallback.cancel();
                return;
            }
            // IMPORTANT:  FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully DOES NOT mean the Enrollment was Successful.
            // It simply means the User completed the Session and a 3D FaceScan was created.  You still need to perform the Enrollment on your Servers.
            //
            // Part 4:  Get essential data off the FaceTecSessionResult
            //
            var parameters = {
                user_id: _this.userId,  // Pass the user ID for enrollment
                face_scan: sessionResult.faceScan,
                audit_trail_image: sessionResult.auditTrail[0],
                low_quality_audit_trail_image: sessionResult.lowQualityAuditTrail[0],
                user_agent: window.FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId)
            };
            //
            // Part 5:  Make the Networking Call to Your Servers (Xano endpoint)
            //
            _this.latestNetworkRequest = new XMLHttpRequest();
            _this.latestNetworkRequest.open('POST', Config.EnrollmentURL);  // New Xano endpoint
            _this.latestNetworkRequest.setRequestHeader("Content-Type", "application/json");
            
            _this.latestNetworkRequest.onreadystatechange = function () {
                if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                    try {
                        var responseJSON = JSON.parse(_this.latestNetworkRequest.responseText);
                        
                        if (responseJSON.wasProcessed === true) {
                            // Success! Enrollment completed
                            _this.success = true;
                            faceScanResultCallback.succeed();
                        } else {
                            // Failed enrollment
                            _this.success = false;
                            faceScanResultCallback.retry();
                        }
                    }
                    catch (_e) {
                        _this.cancelDueToNetworkError("Exception while handling API response, cancelling out.", faceScanResultCallback);
                    }
                }
            };
            
            _this.latestNetworkRequest.onerror = function () {
                _this.cancelDueToNetworkError("XHR error, cancelling.", faceScanResultCallback);
            };
            
            //
            // Part 7:  Demonstrates updating the Progress Bar based on the progress event.
            //
            _this.latestNetworkRequest.upload.onprogress = function (event) {
                var progress = event.loaded / event.total;
                faceScanResultCallback.uploadProgress(progress);
            };
            
            //
            // Part 8:  Actually send the request.
            //
            var jsonStringToUpload = JSON.stringify(parameters);
            _this.latestNetworkRequest.send(jsonStringToUpload);
            
            //
            // Part 9:  For better UX, update the User if the upload is taking a while.
            //
            window.setTimeout(function () {
                if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                    return;
                }
                faceScanResultCallback.uploadMessageOverride("Still Uploading...");
            }, 6000);
        };
        
        //
        // Part 10:  This function gets called after the FaceTec SDK is completely done.
        //
        this.onFaceTecSDKCompletelyDone = function () {
            _this.success = (_this.latestNetworkRequest.status === 200 && _this.latestSessionResult.status === 0);
            
            // Log success message
            if (_this.success) {
                DeveloperStatusMessages.logMessage("User Enrolled Successfully");
            }
            
            // Call React callback instead of sampleAppControllerReference.onComplete
            if (_this.callback) {
                _this.callback({
                    success: _this.success,
                    sessionResult: _this.latestSessionResult,
                    networkRequestStatus: _this.latestNetworkRequest.status,
                    userId: _this.userId
                });
            }
        };
        
        // Helper function to ensure the session is only cancelled once
        this.cancelDueToNetworkError = function (networkErrorMessage, faceScanResultCallback) {
            if (_this.cancelledDueToNetworkError === false) {
                console.error(networkErrorMessage);
                _this.cancelledDueToNetworkError = true;
                faceScanResultCallback.cancel();
            }
        };
        
        //
        // DEVELOPER NOTE:  These properties are for demonstration purposes only so the Sample App can get information about what is happening in the processor.
        //
        this.success = false;
        this.userId = userId;           // Store user ID for enrollment
        this.callback = callback;       // React callback instead of sampleAppControllerReference
        this.latestSessionResult = null;
        this.cancelledDueToNetworkError = false;
        
        //
        // Part 1:  Starting the FaceTec Session
        //
        new window.FaceTecSDK.FaceTecSession(this, sessionToken);
    }
    return EnrollmentProcessor;
}());